import { Select, SelectContent, SelectGroup, SelectItem, SelectTrigger } from "@/components/ui/select";
import { SortPredictionMarketEnum } from "@roman/shared/hooks/PredictionMarket/usePredictionMarketLabels";

type SelectSortPredictionMarketProps = {
  selectedSortPredictionMarketType: SortPredictionMarketEnum;
  setSelectedSortPredictionMarketType: (selectedSortPredictionMarketType: SortPredictionMarketEnum) => void;
  className?: string;
};

export const SelectSortPredictionMarket = ({
  selectedSortPredictionMarketType,
  setSelectedSortPredictionMarketType,
  className,
}: SelectSortPredictionMarketProps) => {
  return (
    <Select
      value={selectedSortPredictionMarketType}
      onValueChange={(value: SortPredictionMarketEnum) => setSelectedSortPredictionMarketType(value)}
    >
      <SelectTrigger
        className={`shadow-none border-[#C8D2FF] bg-white max-w-fit rounded-lg text-[#758FFF] font-semibold ring-0 focus:ring-0 text-center hover:bg-[#4B57FF]/10 ${className ?? ""}`.trim()}
        iconClassName="opacity-100 text-[#758FFF] w-5 h-5"
      >
        <p className="w-full text-center px-[2px] text-xs font-bold">{selectedSortPredictionMarketType}</p>
      </SelectTrigger>

      <SelectContent className="rounded-lg">
        <SelectGroup>
          {Object.values(SortPredictionMarketEnum).map((value) => (
            <SelectItem key={value} value={value}>
              {value}{" "}
            </SelectItem>
          ))}
        </SelectGroup>
      </SelectContent>
    </Select>
  );
};
export { SortPredictionMarketEnum };
